import { setSpecificMessage, minBytes } from "valibot";
setSpecificMessage(
  minBytes,
  (issue) => `Octet invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);